import { Row } from '@/components/layout/layout'
import { getBEMCls } from '@/utils/classname'
import classNames from 'classnames'
import { observer } from 'mobx-react'
import React from 'react'
import { GoodsModel } from '../model'
import Select from '../../../../../../../../../../components/input/select'
import { useField, useFormikContext } from 'formik'
import { showLayer } from '@/utils/layer'
import { Select as AntSelect } from 'formik-antd'
import { ChooseGoodsCategoryDialog } from '../goods-category/goods-category'
import { IgoodsForm } from '../../edit-goods'

export const GoodsCategoryFormItem: React.FC<{
    goodsModel: GoodsModel
}> = observer(props => {
    const [, , helpers] = useField('category_id')
    const { values } = useFormikContext<IgoodsForm>()
    const cls = (...args: string[]) => getBEMCls('edit-goods', ...args)

    return (
        <Row data-position-relative data-align-items-center data-padding-h-24>
            <span className={classNames(cls('form-item', 'title'))}>商品类目</span>
            <Select
                name="category_id"
                showSearch
                placeholder="输入关键词搜索类目"
                inputsuffix={() => (
                    <span
                        data-font-size-14
                        data-color-000
                        data-cursor-pointer
                        onClick={() => {
                            showLayer(
                                <ChooseGoodsCategoryDialog
                                    goodsName={values.name}
                                    goodsModel={props.goodsModel}
                                    onChange={item => {
                                        helpers.setValue(item.id)
                                    }}
                                ></ChooseGoodsCategoryDialog>,
                            )
                        }}
                    >
                        类目列表
                        <i data-color-999 className="iconfont icon6youjiantou-20"></i>
                    </span>
                )}
            >
                {props.goodsModel.goodsCategory.map(val => {
                    return (
                        <AntSelect.Option key={val.id} value={val.id}>
                            {val.name}
                        </AntSelect.Option>
                    )
                })}
            </Select>
        </Row>
    )
})
